module.exports = __webpack_public_path__ + "img/gloves.be5030ca.webp";